import { usePage } from '@inertiajs/react'
import { useEffect, useRef } from 'react'

const FADE_MS = 400 // 従来の jQuery fadeIn / fadeOut と同じ
const SHOW_MS = 3000

/** Rails の flash（notice / alert）。従来の layout の .popup-alert と同じ場所・見た目で、表示のたびにフェードする */
export function FlashMessages() {
  const { flash } = usePage()
  const ref = useRef<HTMLDivElement>(null)
  const visible = Boolean(flash.notice || flash.alert)

  useEffect(() => {
    const el = ref.current
    if (!el || !visible) return
    el.style.display = ''
    el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FADE_MS })
    const timer = setTimeout(() => {
      el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE_MS }).onfinish = () => {
        el.style.display = 'none'
      }
    }, SHOW_MS)
    return () => clearTimeout(timer)
  }, [flash, visible])

  return (
    <div className="popup-alert">
      <div className="container" id="flash-messages">
        {visible && (
          <div ref={ref}>
            {flash.notice && (
              <div className="alert alert-success" role="alert">
                {flash.notice}
              </div>
            )}
            {flash.alert && (
              <div className="alert alert-warning" role="alert">
                {flash.alert}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
